/**
 * Tiny count pill — hidden when count is 0. Used by:
 *   - Tab strip (NIT-001)
 *   - Navbar Queue pill (NIT-009)
 *   - Active transaction count
 */

interface Props {
  readonly count: number;
  /** Tailwind colour classes; default emerald. */
  readonly tone?: 'emerald' | 'amber' | 'rose' | 'sky' | 'slate';
  readonly testId?: string;
  /** Override the rendered string (e.g. "Queue: 3"). Defaults to the count itself. */
  readonly label?: string;
}

const TONE: Record<NonNullable<Props['tone']>, string> = {
  emerald: 'bg-primary-base/80 text-primary-on',
  amber: 'bg-amber-700/80 text-amber-50',
  rose: 'bg-rose-700/80 text-rose-50',
  sky: 'bg-sky-700/80 text-sky-50',
  slate: 'bg-slate-700/80 text-slate-200',
};

export function CountBadge({ count, tone = 'emerald', testId, label }: Props): JSX.Element | null {
  if (count <= 0) return null;
  return (
    <span
      className={`ml-1 inline-flex min-w-[1.25rem] items-center justify-center rounded-full px-1.5 py-0.5 text-[10px] font-medium ${TONE[tone]}`}
      data-testid={testId !== undefined ? `count-${testId}` : 'count'}
    >
      {label ?? count}
    </span>
  );
}
